import { gql } from "@apollo/client"

export const GET_GPRA_STATUS = gql`
  query isMicroservicesActive($staff_id: ID!, $organization_id: ID!) {
    isMicroservicesActive(
      staff_id: $staff_id
      organization_id: $organization_id
      microservice_name: "GPRA"
    ) {
      microservices_id
      microservices_name
      microservices_enabled
    }
  }
`
